<template>
<div>
<p>
Team extension is an efficient way for a company to get the required expert resources.  It is very flexible, adaptable and cost-effective.
</p>
<p>
What options do you have when you need :
<ol>
 <li>to develop a new product fast</li>
 <li>reduce development costs</li>
 <li>urgently require more people to support your systems</li>
 <li>to have a contingency plan in case the current IT suppliers unable to deliver promises</li>
</ol>
</p>
<p>
In order to overcome IT resources fluctuation and be able to react to business needs you usually have 3 options:
<ol>
<li> hire contractors - IT experts that work at your premises as part of your team.</li>
<li> insource people - remotely working IT experts that work as your team members</li>
<li> outsource project - hire another company to manage the development work and produce the product you need.</li>
</ol>
</p>
<p>
All the options have their advantages and disadvantages, and the best solution is the mix of all of them. This is the team extension model where 10% of the external team work at the company and the rest 90% work remotely, assuring best communication, knowledge transfer, progress and plan change management while reducing development costs and assuring fast reaction to changing human resource change requirements.
</p>
</div>
</template>

<script>
export default {
	data() {
		return {
			metadata: {
				section: "service",
				title: "IT Team Extension"
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
